import { useEffect, useRef, useState } from "react";
import { TYPO } from "styles/Typo";
import FundamentalModal from "./FundamentalModal";
import { TAILWIND_TO_CSS } from "utils/constant/STYLE";
import useIsDetailLoading from "states/detailLoading";
import { useAutoToggleOpen } from "./useAutoToggleOpen";
import ToggleButton from "components/common/ToggleButton";
import { useParams } from "next/navigation";
import { useRouter } from "next/router";
import { useTranslation } from "next-i18next";
import EmptyData from "../EmptyData";
import moment from "moment-timezone";
import { trackPageAction } from "lib/analytics/core/actions";

function FundamentalKeywordBlock({
  item,
  type,
  index,
  firstOpen,
  toggleTrigger,
}: {
  item: any;
  type: "up" | "down";
  index: number;
  firstOpen: boolean;
  toggleTrigger: boolean;
}) {
  const [isOpen, setIsOpen] = useState(firstOpen);
  const [height, setHeight] = useState(0);
  const virtualRef = useRef<HTMLDivElement>(null);
  // console.log("** height", height);
  useEffect(() => {
    if (virtualRef.current) {
      // console.log("** virtualRef.current", virtualRef.current.clientHeight);
      setHeight(virtualRef.current.offsetHeight);
    }
  }, [virtualRef]);
  useEffect(() => {
    if (height > 0) {
      setIsOpen(firstOpen);
    }
  }, [firstOpen, height]);
  useEffect(() => {
    if (isOpen) {
      setIsOpen(false);
    }
  }, [toggleTrigger]);
  return (
    <div
      className="overflow-hidden cursor-pointer "
      onClick={() => {
        trackPageAction(
          isOpen ? "collapse_stock_fundamental" : "expand_stock_fundamental"
        );
        setIsOpen(!isOpen);
      }}
      data-gtm-id={`sDetail-value-scouter-${type}-keyword`}
    >
      <div
        className={`px-4 py-[10px] flex justify-between items-center bg-gray2 cursor-pointer ${
          index === 0 ? "" : "border-t border-gray15"
        }`}
        onClick={() => {
          setIsOpen(!isOpen);
        }}
      >
        <p
          className={`${TYPO.TYPO6_MD} text-gray80 whitespace-nowrap !leading-[26px]`}
          data-testid={`value-scouter-fundamental-${type}-keyword`}
        >
          {item?.keyword}
        </p>
        <div
          style={{
            transform: isOpen ? "rotate(0deg)" : "rotate(180deg)",
            transition: "transform 0.6s ease",
          }}
        >
          <ArrowIcon />
        </div>
      </div>
      {/** 가상 컴포넌트 - 높이 측정용 */}
      <div className="relative">
        <div
          className="flex items-center  overflow-hidden invisible opacity-[0] z-[-1] absolute top-0 left-0 w-full h-fit"
          ref={virtualRef}
        >
          <div className="px-4 py-5 flex flex-col gap-2">
            {type === "up" ? (
              <div className="rounded-[6.005px] w-[18px] h-[18px] bg-risk-green ">
                <UpIcon />
              </div>
            ) : (
              <div className="rounded-[6.005px] w-[18px] h-[18px] bg-risk-red">
                <DownIcon />
              </div>
            )}
            <p
              className={`${TYPO.TYPO7_1_RG} text-gray70`}
              style={{
                wordWrap: "break-word",
                wordBreak: "keep-all",
                whiteSpace: "normal",
                overflowWrap: "break-word",
              }}
            >
              {item?.description}
            </p>
          </div>
        </div>
        <div
          className="flex items-center  overflow-hidden "
          style={{
            maxHeight: isOpen ? `${height}px` : "0px",
            opacity: isOpen ? 1 : 0,
            borderTop: isOpen
              ? `1px solid ${TAILWIND_TO_CSS["gray15"]}`
              : "none",
            transition: "max-height 0.6s ease, opacity 0.6s 0.1s ease",
            background:
              type === "up"
                ? "linear-gradient(0deg, rgba(255, 255, 255, 0.10) 50%, rgba(33, 212, 126, 0.05) 100%), var(--neutral-white, #FFF)"
                : "linear-gradient(0deg, rgba(255, 255, 255, 0.10) 50%, rgba(255, 102, 102, 0.05) 100%), var(--neutral-white, #FFF)",
          }}
        >
          <div className="px-4 py-5 flex flex-col gap-2">
            {type === "up" ? (
              <div className="rounded-[6.005px] w-[18px] h-[18px] bg-risk-green ">
                <UpIcon />
              </div>
            ) : (
              <div className="rounded-[6.005px] w-[18px] h-[18px] bg-risk-red">
                <DownIcon />
              </div>
            )}
            <p
              className={`${TYPO.TYPO7_1_RG} text-gray70`}
              style={{
                wordWrap: "break-word",
                wordBreak: "keep-all",
                whiteSpace: "normal",
                overflowWrap: "break-word",
              }}
            >
              {item?.description}
            </p>
          </div>
        </div>
      </div>

      {/* {isOpen && (
        <FundamentalModal
          setModalOpen={setIsOpen}
          isModalOpen={isOpen}
          item={item}
          type={type}
        />
      )} */}
    </div>
  );
}

function FundamentalItem({
  type,
  data,
  toggleTrigger,
}: {
  type: "up" | "down";
  data: any;
  toggleTrigger: boolean;
}) {
  // // 뷰포트 기준 70%에 해당 컴포넌트가 보이면 block의 첫번째 토글 자동 오픈
  // const [firstOpen, setFirstOpen] = useState(false);
  // // throttle + requestAnimationFrame 직접 구현
  // let ticking = false;
  // const lastRan = useRef(0);
  // const throttleDelay = 200; // ms
  // useEffect(() => {
  //   if (firstOpen) return; // 이미 열렸으면 리스너 등록 X

  //   const handleScroll = () => {
  //     if (!ticking) {
  //       window.requestAnimationFrame(() => {
  //         const now = Date.now();
  //         if (now - lastRan.current > throttleDelay) {
  //           const block = document.querySelector(
  //             `#value-scouter-fundamental-${type}`
  //           );
  //           if (block) {
  //             const blockRect = block.getBoundingClientRect();
  //             if (blockRect.top <= window.innerHeight * 0.7) {
  //               setFirstOpen(true);
  //             }
  //           }
  //           lastRan.current = now;
  //         }
  //         ticking = false;
  //       });
  //       ticking = true;
  //     }
  //   };

  //   window.addEventListener("scroll", handleScroll);
  //   // mount 시에도 한 번 체크
  //   handleScroll();

  //   return () => {
  //     window.removeEventListener("scroll", handleScroll);
  //   };
  // }, [firstOpen, type]);
  const firstOpen = useAutoToggleOpen({
    wrapId: `value-scouter-fundamental-${type}`,
  });
  return (
    <div
      className="flex flex-col overflow-hidden rounded-[10px] border border-gray15"
      id={`value-scouter-fundamental-${type}`}
    >
      {data?.map((item: any, index: number) => (
        <FundamentalKeywordBlock
          key={index}
          item={item}
          type={type}
          index={index}
          firstOpen={index === 0 ? firstOpen : false}
          toggleTrigger={toggleTrigger}
        />
      ))}
    </div>
  );
}

function Fundamental({ momentumExplainData }: { momentumExplainData: any }) {
  const [toggle, setToggle] = useState<"up" | "down">("up");
  const { ticker } = useParams();
  const router = useRouter();
  const { t } = useTranslation("detail");
  const [toggleTrigger, setToggleTrigger] = useState(false);
  const isLoading = useIsDetailLoading();
  console.log("momentumExplainData", momentumExplainData);
  const lastUpdate =
    router.locale === "ko"
      ? moment(momentumExplainData?.[0]?.issue_at).format("M월 D일")
      : moment(momentumExplainData?.[0]?.issue_at).format("MMM D");

  if (isLoading) return null;
  if (momentumExplainData?.length === 0)
    return (
      <div className="py-6 pt-[30px] !pb-1 flex flex-col gap-4">
        <div className="flex items-center justify-between px-6">
          <h3 className={`${TYPO.TYPO6_SB} text-gray90`}>{t("fundamentals")}</h3>
        </div>
        <div className="px-6">
          <EmptyData />
        </div>
      </div>
    );

  const filteredMomentumExplainData = momentumExplainData?.filter(
    (item: any) => !item?.keyword?.includes("없") && item?.description
  );

  const upDatas = filteredMomentumExplainData?.filter(
    (item: any) => item?.momentum_type === "up"
  );
  const downDatas = filteredMomentumExplainData?.filter(
    (item: any) => item?.momentum_type === "down"
  );

  return (
    <div className="py-6 pt-[30px] !pb-1 flex flex-col gap-4">
      <div className="flex items-center justify-between px-6">
        <h3 className={`${TYPO.TYPO6_SB} text-gray90`}>{t("fundamentals")}</h3>
        <ToggleButton
          dataGtmId={"sDetail-value-scouter-toggle"}
          active={toggle === "up" ? 1 : 2}
          setActive={(active) => {
            setToggleTrigger(!toggleTrigger);
            setTimeout(() => {
              setToggle(active === 1 ? "up" : "down");
            }, 700);
            trackPageAction("toggle_stock_fundamental");
          }}
          title1={t("positive")}
          title2={t("negative")}
        />
      </div>
      <div className="flex flex-col gap-1">
        <div className="flex flex-col gap-6 px-6">
          {upDatas?.length > 0 && toggle === "up" && (
            <FundamentalItem
              type="up"
              data={upDatas}
              toggleTrigger={toggleTrigger}
            />
          )}
          {downDatas?.length > 0 && toggle === "down" && (
            <FundamentalItem
              type="down"
              data={downDatas}
              toggleTrigger={toggleTrigger}
            />
          )}
        </div>
        <div className="flex items-center justify-end px-6">
          <p className={`${TYPO.TYPO8_RG} text-gray40`}>
            {t("lastUpdated", { date: lastUpdate })}
          </p>
        </div>
      </div>
    </div>
  );
}

const UpIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        d="M7.16131 11.3625L13.5176 5.00625C13.6676 4.85625 13.8457 4.78125 14.0519 4.78125C14.2582 4.78125 14.4363 4.85625 14.5863 5.00625C14.7363 5.15625 14.8113 5.33437 14.8113 5.54062C14.8113 5.74687 14.7363 5.925 14.5863 6.075L7.68631 12.975C7.53631 13.125 7.36131 13.2 7.16131 13.2C6.96131 13.2 6.78631 13.125 6.63631 12.975L3.41131 9.75C3.26131 9.6 3.18944 9.42187 3.19569 9.21562C3.20194 9.00937 3.28006 8.83125 3.43006 8.68125C3.58006 8.53125 3.75819 8.45625 3.96444 8.45625C4.17069 8.45625 4.34881 8.53125 4.49881 8.68125L7.16131 11.3625Z"
        fill="white"
      />
    </svg>
  );
};

const DownIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M4 8H12"
        stroke="white"
        strokeWidth="1.33333"
        strokeLinecap="round"
      />
    </svg>
  );
};
const ArrowIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
    >
      <path
        d="M6.02167 4.3625L2.34667 8.0375C2.22167 8.1625 2.07584 8.22292 1.90917 8.21875C1.74251 8.21458 1.59667 8.15 1.47167 8.025C1.34667 7.9 1.28417 7.75417 1.28417 7.5875C1.28417 7.42083 1.34667 7.275 1.47167 7.15L5.30917 3.3C5.40917 3.2 5.52167 3.125 5.64667 3.075C5.77167 3.025 5.89667 3 6.02167 3C6.14667 3 6.27167 3.025 6.39667 3.075C6.52167 3.125 6.63417 3.2 6.73417 3.3L10.5842 7.15C10.7092 7.275 10.7696 7.42292 10.7654 7.59375C10.7613 7.76458 10.6967 7.9125 10.5717 8.0375C10.4467 8.1625 10.3008 8.225 10.1342 8.225C9.96751 8.225 9.82167 8.1625 9.69667 8.0375L6.02167 4.3625Z"
        fill="var(--gray40)"
      />
    </svg>
  );
};
export default Fundamental;
